import Styles from '../WizardsDrawerV4.module.scss'
import { Level1 } from './Level1/Level1'
import { Level } from '../Types'
import { SocialMedia } from './Level2/SocialMedia/SocialMedia'
import { Video } from './Level2/Video/Video'
import { BlogSEO } from './Level2/BlogSEO/BlogSEO'
import { ProductCopy } from './Level3/ProductCopy/ProductCopy'
import { BrainstormIdeas } from './Level2/BrainstormIdeas/BrainstormIdeas'
import { LevelProps } from '../Types'
import { Instagram } from './Level3/Instagram/Instagram'
import { Facebook } from './Level3/Facebook/Facebook'
import { LinkedIn } from './Level3/LinkedIn/LinkedIn'
import { Twitter } from './Level3/Twitter/Twitter'
import { TikTok } from './Level3/TikTok/TikTok'
import { YouTube } from './Level3/YouTube/YouTube'
import { Pinterest } from './Level3/Pinterest/Pinterest'
import { WhatsApp } from './Level3/WhatsApp/WhatsApp'
import { TurnInto } from './Level3/TurnInto/TurnInto'
import { Newsletter } from './Level3/Newsletter/Newsletter'
import { Lifecycle } from './Level3/Lifecycle/Lifecycle'
import { ECommerce } from './Level3/ECommerce/ECommerce'
import { EmailSales } from './Level3/EmailSales/EmailSales'
import { Websites } from './Level3/Websites/Websites'
import { Sales } from './Level3/Sales/Sales'
import { CustomerSupport } from './Level3/CustomerSupport/CustomerSupport'
import { Recruiting } from './Level3/Recruiting/Recruiting'
import { AdCopy } from './Level3/AdCopy/AdCopy'
import { ProductVisual } from './Level3/ProductVisual/ProductVisual'
import { Marketplace } from './Level2/Marketplace/Marketplace'
import { RecentlyUsed } from './Level2/RecentlyUsed/RecentlyUsed'
import { LinkedInPost } from './Level4/LinkedInPost/LinkedInPost'
import { TwitterPost } from './Level4/TwitterPost/TwitterPost'

const ComponentMap: Record<Level, React.FunctionComponent<LevelProps>> = {
  // L1
  create_new: Level1,
  new_document: () => null, // handled differently
  new_design: () => null, // handleed differently

  // L2
  social_media: SocialMedia,
  marketplace: Marketplace,
  video: Video,
  blogs_seo: BlogSEO,
  brainstorm_ideas: BrainstormIdeas,
  ad_copy: AdCopy,
  recently_used: RecentlyUsed,

  // L3
  instagram: Instagram,
  facebook: Facebook,
  linkedin: LinkedIn,
  twitter: Twitter,
  tiktok: TikTok,
  youtube: YouTube,
  pinterest: Pinterest,
  whatsapp: WhatsApp,
  product_copy: ProductCopy,
  product_visual: ProductVisual,
  turn_into: TurnInto,
  newsletter: Newsletter,
  lifecycle: Lifecycle,
  ecommerce: ECommerce,
  email_sales: EmailSales,
  websites: Websites,
  sales: Sales,
  customer_support: CustomerSupport,
  recruiting: Recruiting,

  // L4
  linkedin_post: LinkedInPost,
  twitter_post: TwitterPost,
}

export const CreateNew = (props: LevelProps) => {
  const { level } = props

  const Main = ComponentMap[level] ?? Level1

  return (
    <div className={Styles.createNew}>
      <Main {...props} />
    </div>
  )
}
